import { Controller } from '@hotwired/stimulus'
import DevLog from './shared/DevLog'
import CatchError from './shared/CatchError'
import { GoogleMapsLoader, DrawMap } from './loaders/GoogleMapsLoader'

export default class extends Controller {
  static values = {
    apiKey: String,
    latitude: String,
    longitude: Number,
    label: String,
    zoom: Number,
    mapId: String
  }

  connect () {
    DevLog(['Google Maps loading'])

    GoogleMapsLoader(this.apiKeyValue).then(() => {
      const mapElement = this.element
      const lat = parseFloat(this.latitudeValue) || 0
      const lng = parseFloat(this.longitudeValue) || 0
      const position = { lat, lng }
      const label = this.labelValue || ''
      const mapId = this.mapIdValue
      DevLog(['Google Maps drawing:', position, label, 'mapId:', mapId])

      DrawMap({ mapElement, position, label, mapId })
    }).catch((error) => {
      // Google Maps failures can happen due to network issues or API limits
      DevLog(['Google Maps failed to load:', error.message])

      // Hide the map element if it failed to load
      if (this.element) {
        this.element.style.display = 'none'
      }

      CatchError(error, {
        controller: 'google_maps',
        apiKey: this.apiKeyValue ? 'present' : 'missing',
        position: { lat: this.latitudeValue, lng: this.longitudeValue },
        mapId: this.mapIdValue
      })
    })
  }
}
